import { Box, Divider, Grid, InputAdornment, Typography } from "@mui/material";
import React, { createContext, useEffect, useState,useContext} from "react";
import styles from "./formFour.module.scss";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import {
  CommonButton,
  CommonOutlinedButton,
  ContactNumberInput,
  CustomNumberFeildForHallSchedule,
  CustomRequiredInputLabel,
  CustomTextFeildForHallSchedule,
  CustomTextFeildforFamily,
} from "../../common/StyledComponents/StyledFields";
import {
  apiRequest,
  catchErrorMessageHandler,
  getUserName,
  getUserSelectedRole,
} from "../../../infrastructure/backendService";
import SuccessPopup from "../../devotee/donation/successPopup";
import LOCALE from "../../../config/en-us.json";
import ToastError from "../../common/toast/toastError";
import toast, { Toaster } from "react-hot-toast";
import ToastSuccess from "../../common/toast/toastSuccess";
import { object, string, ref, ValidationError, number } from "yup";
import {
  TextField,
  styled,
  Dialog,
  DialogTitle,
  IconButton,
  DialogContent,
  DialogContentText,
  DialogActions,
} from "@mui/material";
import ErrorPopup from "../../common/ErrorPopup";
import constants from "../../../config/constants.json";
import { useSearchParams } from 'react-router-dom';
import { isNil } from 'lodash';
import apiPath from '../../../config/apiPaths.json';
import FormFive from "../formFive";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import FormFooter from "../formFooter";
import { HallBookingRequestResponseContext } from "../formOne/facilityUsageAgreementForm";
interface Hall {
  id: number;
  name: string;
  description: string;
  area: string;
  minimumHours: number;
  minimumFee: number;
  hourlyFee: number;
  setupAndCleaning: number;
  securityDeposit: number;
  cancellationFee: number;
  incomeAccount: string;
  enteredBy: string | null;
  enteredOn: string | null;
  modifiedBy: string;
  modifiedOn: string;
  deleted: boolean;
  deletedBy: string | null;
  deletedOn: string | null;
  hallCapacity: {
      capacity: number;
      banquetCapacity: number;
  };
}

interface Category {
  category: string;
  eventHalls: Hall[];
}
interface fromFourProps {
  updateParentState: (newState: boolean) => void;
  formData: any;
  sign: string;
  handleInputChange: any
}

interface fromFourProps {
  updateParentState : (newState:boolean) => void;
  formData:any;
  sign:string;
  handleInputChange:any,
  hallList:any
}
interface fromFourProps {
  updateParentState : (newState:boolean) => void;
  formData:any;
}
interface ErrorMessageTypes {
  user: string;
  date: string;
  phone: string;
  usernames: string;
  address1: string;
  address2: string;
  zipcode: string;
  city: string;
  state: string;
  alternateNo: string;
}

interface ErrorMessageManagerFormTypes {
  hccc: string;
  date: string;
  phone: string;
}

interface Object1Type {
  reservationFee: string,
  furnitureCharges: string,
  securityDeposit: string,
  initialAmount: string,
  finalAmount: string,
  hccc: string,
  date: string,
  phone: string,
}

interface contextTypes {
  object1: Object1Type;
  object2: Hall | null;
}

export const ContextFour = createContext<contextTypes | undefined>(undefined);


const FacilityUsageAgreementAcknowledgement = (props: fromFourProps): JSX.Element => {
const viewContractFormResponse = useContext(HallBookingRequestResponseContext);

  const [isEmpty, setIsEmpty] = useState(false);


  const handleNext = () => {
    //
    if(hasManagerLevelRole) {
      if(amountData.reservationFee === "" || amountData.initialAmount=== "" || amountData.finalAmount === "" || managerFormData.date === "" || managerFormData.hccc === "" || managerFormData.phone === "") {
        setIsEmpty(true);
        setNextStep(false);
      } else {
        setIsEmpty(false);
        setNextStep(true);
        window.scrollTo({ top: 0, behavior: "smooth" });
      }
    } else {
      setIsEmpty(false);
      setNextStep(true);
      window.scrollTo({ top: 0, behavior: "smooth" });
      setFormData((prevState: any) => ({
      ...prevState,
      contractForm: {
        ...prevState.contractForm,
        alternatePhoneNumber: alternateNo,
      },
    }));

    }
  };
  const [searchParam] = useSearchParams();
  const username = searchParam.get("username");
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const formFields = {
    user: "",
    date: "",
    phone: "",
    usernames: "",
    address1: "",
    address2: "",
    zipcode: "",
    city: "",
    state: "",
    country: "",
    alternateNo: "",
  };

  const amountFields = {
    reservationFee: "",
    furnitureCharges: "",
    securityDeposit: "",
    initialAmount: "",
    finalAmount: "",
  };

  const managerFormFields = {
    hccc: "",
    date: "",
    phone: "",
  };
  const devoteeDetailsFeilds = {
    fullName: "",
    username: username || "",
    zipcode: "",
    city: "",
    state: "",
    country: "",
    address: "",
    phoneNumber: "",
    altPhoneNumber: ""
  }

  const [formData, setFormData] = useState({ ...props.formData });
  const [amountData, setAmountData] = useState({ ...amountFields });
  const [managerFormData, setManagerFormData] = useState({
    ...managerFormFields,
  });
  const [errorMessage, setErrorMessage] = useState<ErrorMessageTypes>({
    ...formFields,
  });
  const [errorMessageManagerForm, setErrorMessageManagerForm] =
    useState<ErrorMessageManagerFormTypes>({
      ...managerFormFields,
    });
  const [devoteeDetails, setDevoteeDetails] = useState({ ...devoteeDetailsFeilds });
  const hasManagerLevelRole = constants.showDashBoardForRoles.includes(getUserSelectedRole() || "");
  const [nextStep, setNextStep] = useState(false);
  const [alternateNo, setAlternateNo] = useState("");
  const [contextHallObject, setContextHallObject] = useState<Hall | null>(null);
  const status=searchParam.get("STATUS");
  const hallBookingId=searchParam.get("hallBookingId");
  const contractId=searchParam.get("contractId");
  const [initialAmount,setInitialAmount]=useState(0);
  const [finalAmount,setFinalAmount]=useState(0);


  useEffect(()=>{
    handleAmount();
  },[initialAmount,finalAmount]);

  useEffect(()=>{
    if(hasManagerLevelRole) {
      apiRequest({
        method: "GET",
        endpoint: `${apiPath.getDevoteeDetails}/${getUserName()?.toUpperCase()}`,
        includeToken: true,
      })
      .then((res)=>{
        console.log(res.data);
        // Create a new Date object for the current date
      const currentDate = new Date();
      // Format the date as m-dd-yyyy
      const formattedDate = `${(currentDate.getMonth() + 1).toString().padStart(2, '0')}-${currentDate.getDate().toString().padStart(2, '0')}-${currentDate.getFullYear()}`;
        setManagerFormData({
          ...managerFormData,
          hccc: res.data.username,
          date: formattedDate,
          phone: "+1 (925) 449 6255",
        });
      })
      .catch((err)=>{
        console.log(err)
      })
    }
  },[managerFormData.hccc])
  
  const handleAmount=()=>{
    if(status=="FORM_TO_BE_SIGNED" || "formcontractform") {
      apiRequest({
        method: "GET",
        endpoint: `${apiPath.contractFormHallBookingManagerFlow}/${hallBookingId}/contracts/${contractId}`,
        includeToken: true,
      })
        .then((res) => {
          setInitialAmount(res.data.initialAmountToPay);
		      setFinalAmount(res.data.finalAmountToPay);
          setManagerFormData({
            ...managerFormData,
            hccc: res.data.managerUsername,
            date:res.data.managerAcknowledgedAuthorityToSignDate,
            phone:res.data.managerPhoneNumber
          });
        })
        .catch((err) => {
          console.log(err);
        });
  }}


  useEffect(() => {
    if (!isNil(username)) {
      apiRequest({
        method: "GET",
        endpoint: `${apiPath.getDevoteeDetails}/${username?.toUpperCase()}`,
        includeToken: true,
      })
        .then((res) => {
          console.log(res.data, "first...............");
          setDevoteeDetails({
            ...devoteeDetails,
            fullName: `${res.data.firstname} ${res.data.middleName} ${res.data.lastname}`,
            zipcode: res.data.zipcode,
            state: res.data.state,
            country: res.data.country,
            address: res.data.address,
            phoneNumber: res.data.phoneWork,
            altPhoneNumber: res.data.phoneResidence,
            city: res.data.city,
          });
          setFormData((prevState: any) => ({
            ...prevState,
            contractForm: {
              ...prevState.contractForm,
              devoteeFullname: `${res.data.firstname} ${res.data.middleName} ${res.data.lastname}`,
              zipcode: res.data.zipcode,
              state: res.data.state,
              country: res.data.country,
              address: res.data.address,
              phoneNumber: res.data.phoneWork,
              alternatePhoneNumber: res.data.phoneResidence,
              city: res.data.city,
              email: res.data.email
            },
          }));
        })
        .catch((err) => {
          console.log(err);
          toast.custom(
            <ErrorPopup
              showMessage={catchErrorMessageHandler(err)}
              isOpen={false}
            />,
            {
              duration: constants.TOAST_POPUP_DURATION,
            }
          );
        });
    }
  }, []);

  
  useEffect(() => {
    function findHallById(data: Category[], id: number): Hall | null {
        for (let category of data) {
            let hall = category.eventHalls.find((h: Hall) => h.id === id);
            if (hall) {
                return hall;
            }
        }
        return null;
    }

    const hallIds = props.formData.contractForm.eventHallId;
    let  reservationFee = 0 ,furnitureCharges  = 0 , securityDeposits = 0;
    hallIds.forEach( (hid :any) =>{
      let hallObject = findHallById(props.hallList, hid);
      if (hallObject) {
        setContextHallObject(hallObject)
        let hoursCal = props.formData.duration - hallObject.minimumHours;
        const { minimumFee, setupAndCleaning, securityDeposit, hourlyFee} = hallObject;
        reservationFee = reservationFee + minimumFee + hoursCal * hourlyFee;
        furnitureCharges = furnitureCharges + setupAndCleaning;
        securityDeposits = securityDeposits + securityDeposit;
        
        // Updating the state with the extracted values
        
    }
    setAmountData({
      reservationFee: reservationFee.toString(),
      furnitureCharges: furnitureCharges.toString(),
      securityDeposit: securityDeposits.toString(),
      initialAmount: "", 
      finalAmount: "",
  });
    })
    //let hallObject = findHallById(props.hallList, props.formData.hallId);

    
}, [props.hallList, props.formData.hallId]);

  const validationSchema = object().shape({
    user: string().required("User is Required"),
    date: string().required("Date is Required"),
    phone: string().required("Phone Number is Required"),
    usernames: string().required("Username is Required"),
    address1: string().required("Address1 is Required"),
    address2: string().required("Address2 is Required"),
    zipcode: string().required("Street is Required"),
    city: string().required("City is Required"),
    state: string().required("State is Required"),
  });

  const handleFieldChange = (field: string, value: any) => {
    setFormData({
      ...formData,
      [field]: value,
    });
  };

  const handleFieldAmountChange = (field: string, value: any) => {
    setAmountData({
      ...amountData,
      [field]: value,
    });
  };

  const handleManagerFieldChange = (field: string, value: any) => {
    setManagerFormData({
      ...managerFormData,
      [field]: value,
    });
  };

  const handleSave = async (): Promise<void> => {
    const errors: ErrorMessageTypes = { ...formFields };

    try {
      // Validate the form data against the validation schema
      await validationSchema.validate(formData, { abortEarly: false });
      // If validation passes, you can submit the form
      setErrorMessage(errors);
      // alert('Registration Successful');
      // Call your API or perform other actions here
      saveApiCall();
    } catch (error: any) {
      // Handle validation errors

      if (error instanceof ValidationError) {
        error.inner.forEach((e: any) => {
          if (e.path) {
            errors[e.path as keyof ErrorMessageTypes] = e.message;
          }
        });
      }
      setErrorMessage(errors);
    }
  };

  const saveApiCall = () => {
    const reqBody = {
      user: formData.user,
      date: formData.date,
      phone: formData.phone,
      username: formData.usernames,
      address1: formData.address1,
      address2: formData.address2,
      zipcode: formData.zipcode,
      city: formData.city,
      state: formData.state,
      hccc: managerFormData.hccc,
      managerDate: managerFormData.date,
      managerPhone: managerFormData.phone,
    };
    apiRequest({
      method: "POST",
      endpoint: "",
      body: JSON.stringify(reqBody),
    })
      .then((res) => {
        const successMessage = LOCALE.USER_REGISTER_SUCCESS;
        // toast.custom(<ToastSuccess message={successMessage} />);
        toast.custom(
          <SuccessPopup
            headerMessage="Registration"
            showMessage={successMessage}
            isOpen={isOpen}
            setIsOpen={setIsOpen}
            
          />,
          {
            duration: constants.TOAST_POPUP_DURATION,
          }
        );
        setFormData(formFields);
      })
      .catch((err) => {
        toast.custom(
          <ErrorPopup
            showMessage={catchErrorMessageHandler(err)}
            isOpen={isOpen}
            setIsOpen={setIsOpen}
          />,
          {
            duration: constants.TOAST_POPUP_DURATION,
          }
        );
      });
  };

  console.log(alternateNo, "alternateNo");

  const formComponent = () => {
    return (
      <Grid>
        <Grid container spacing={2} sx={{ pt: 2 }}>
          <Grid xs={12} sm={4} item>
            <Typography>User Full Name</Typography>
            <CustomTextFeildForHallSchedule
              fullWidth
              required
              value={devoteeDetails.fullName}
              onChange={(e) => {
                handleFieldChange("user", e.target.value);
                setErrorMessage({
                  ...errorMessage,
                  user: "",
                });
              }}
              className={
                errorMessage.user ? styles.errorTextField : styles.textField
              }
              inputProps={{
                readOnly: true,
              }}
            />
            {errorMessage.user ? (
              <Typography sx={{ color: "red", fontSize: "12px" }}>
                {errorMessage.user}
              </Typography>
            ) : (
              ""
            )}
          </Grid>
          <Grid xs={12} sm={4} item>
            <Typography>Date</Typography>
            <CustomTextFeildForHallSchedule
              fullWidth
              required
              value={viewContractFormResponse.devoteeAcknowledgedTermsConditionsDate ? viewContractFormResponse.devoteeAcknowledgedTermsConditionsDate : formData.date}
              onChange={(e) => {
                handleFieldChange("date", e.target.value);
                setErrorMessage({
                  ...errorMessage,
                  date: "",
                });
              }}
              className={
                errorMessage.date ? styles.errorTextField : styles.textField
              }
              inputProps={{
                readOnly: true,
              }}
            />
            {errorMessage.date ? (
              <Typography sx={{ color: "red", fontSize: "12px" }}>
                {errorMessage.date}
              </Typography>
            ) : (
              ""
            )}
          </Grid>
          <Grid xs={12} sm={2} item>
            <Typography>Phone</Typography>
            <CustomTextFeildForHallSchedule
              fullWidth
              required
              value={devoteeDetails.phoneNumber}
              onChange={(e) => {
                handleFieldChange("phone", e.target.value);
                setErrorMessage({
                  ...errorMessage,
                  phone: "",
                });
              }}
              className={
                errorMessage.phone ? styles.errorTextField : styles.textField
              }
              inputProps={{
                readOnly: true,
              }}
            />
            {errorMessage.phone ? (
              <Typography sx={{ color: "red", fontSize: "12px" }}>
                {errorMessage.phone}
              </Typography>
            ) : (
              ""
            )}
          </Grid>
          <Grid xs={12} sm={2} item>
            <Typography>Alternative Phone</Typography>
            <CustomTextFeildForHallSchedule
              fullWidth
              required
              value={devoteeDetails.altPhoneNumber}
              onChange={(e) => {
                handleFieldChange("altPhoneNumber", e.target.value);
                setErrorMessage({
                  ...errorMessage,
                  alternateNo: "",
                });
              }}
              className={
                errorMessage.alternateNo
                  ? styles.errorTextField
                  : styles.textField
              }
            />
            {errorMessageManagerForm.phone ? (
              <Typography sx={{ color: "red", fontSize: "12px" }}>
                {errorMessageManagerForm.phone}
              </Typography>
            ) : (
              ""
            )}
            {isEmpty && hasManagerLevelRole && managerFormData.phone == "" && <span style={{color:"red"}}>please enter</span>}
          </Grid>
        </Grid>
        <Grid container spacing={2} sx={{ pt: 2 }}>
          <Grid xs={12} sm={4} item>
            <Typography>Username</Typography>
            <CustomTextFeildForHallSchedule
              fullWidth
              required
              value={devoteeDetails.username}
              onChange={(e) => {
                handleFieldChange("usernames", e.target.value);
                setErrorMessage({
                  ...errorMessage,
                  usernames: "",
                });
              }}
              className={
                errorMessage.usernames
                  ? styles.errorTextField
                  : styles.textField
              }
              inputProps={{
                readOnly: true,
              }}
            />
            {errorMessage.usernames ? (
              <Typography sx={{ color: "red", fontSize: "12px" }}>
                {errorMessage.usernames}
              </Typography>
            ) : (
              ""
            )}
          </Grid>
          <Grid xs={12} sm={4} item>
            <Typography>Address</Typography>
            <CustomTextFeildForHallSchedule
              fullWidth
              required
              value={devoteeDetails.address}
              onChange={(e) => {
                handleFieldChange("address1", e.target.value);
                setErrorMessage({
                  ...errorMessage,
                  address1: "",
                });
              }}
              className={
                errorMessage.address1 ? styles.errorTextField : styles.textField
              }
              inputProps={{
                readOnly: true,
              }}
            />
            {errorMessage.address1 ? (
              <Typography sx={{ color: "red", fontSize: "12px" }}>
                {errorMessage.address1}
              </Typography>
            ) : (
              ""
            )}
          </Grid>
          <Grid xs={12} sm={4} item>
            <Typography>Zipcode</Typography>
            <CustomTextFeildForHallSchedule
              fullWidth
              required
              value={devoteeDetails.zipcode}
              onChange={(e) => {
                handleFieldChange("zipcode", e.target.value);
                setErrorMessage({
                  ...errorMessage,
                  zipcode: "",
                });
              }}
              className={
                errorMessage.zipcode ? styles.errorTextField : styles.textField
              }
              inputProps={{
                readOnly: true,
              }}
            />
            {errorMessage.zipcode ? (
              <Typography sx={{ color: "red", fontSize: "12px" }}>
                {errorMessage.zipcode}
              </Typography>
            ) : (
              ""
            )}
          </Grid>
        </Grid>
        <Grid container spacing={2} sx={{ pt: 2 }}>
          <Grid xs={12} sm={4} item>
            <Typography>City</Typography>
            <CustomTextFeildForHallSchedule
              fullWidth
              required
              value={devoteeDetails.city}
              onChange={(e) => {
                handleFieldChange("city", e.target.value);
                setErrorMessage({
                  ...errorMessage,
                  city: "",
                });
              }}
              className={
                errorMessage.city ? styles.errorTextField : styles.textField
              }
              inputProps={{
                readOnly: true,
              }}
            />
            {errorMessage.city ? (
              <Typography sx={{ color: "red", fontSize: "12px" }}>
                {errorMessage.city}
              </Typography>
            ) : (
              ""
            )}
          </Grid>
          <Grid xs={12} sm={4} item>
            <Typography>State</Typography>
            <CustomTextFeildForHallSchedule
              fullWidth
              required
              value={devoteeDetails.state}
              onChange={(e) => {
                handleFieldChange("state", e.target.value);
                setErrorMessage({
                  ...errorMessage,
                  state: "",
                });
              }}
              className={
                errorMessage.state ? styles.errorTextField : styles.textField
              }
            />
            {errorMessage.state ? (
              <Typography sx={{ color: "red", fontSize: "12px" }}>
                {errorMessage.state}
              </Typography>
            ) : (
              ""
            )}
          </Grid>
          <Grid xs={12} sm={4} item>
            <Typography>Country</Typography>
            <CustomTextFeildForHallSchedule
              fullWidth
              required
              value={devoteeDetails.country}
              onChange={(e) => {
                handleFieldChange("country", e.target.value);
                setErrorMessage({
                  ...errorMessage,
                  city: "",
                });
              }}
              className={
                errorMessage.city ? styles.errorTextField : styles.textField
              }
              inputProps={{
                readOnly: true,
              }}
            />
            {errorMessage.city ? (
              <Typography sx={{ color: "red", fontSize: "12px" }}>
                {errorMessage.city}
              </Typography>
            ) : (
              ""
            )}
          </Grid>
        </Grid>
      </Grid>
    );
  };

  const hcccFieldsComponent = () => {
    return (
      <Grid>
        <Grid container spacing={2}>
          <Grid xs={12} sm={4} item>
            <Typography>HCCC</Typography>
            <CustomTextFeildForHallSchedule
              fullWidth
              required
              value={managerFormData.hccc}
              onChange={(e) => {
                handleManagerFieldChange("hccc", e.target.value);
                setErrorMessageManagerForm({
                  ...errorMessageManagerForm,
                  hccc: "",
                });
              }}
              className={
                errorMessageManagerForm.hccc
                  ? styles.errorTextField
                  : styles.textField
              }
              inputProps={{
                readOnly: !hasManagerLevelRole,
              }}
            />
            {isEmpty && hasManagerLevelRole && managerFormData.hccc == "" && <span style={{color:"red"}}>please enter</span>}
            {/* {errorMessageManagerForm.hccc ? (
              <Typography sx={{ color: "red", fontSize: "12px" }}>
                {errorMessageManagerForm.hccc}
              </Typography>
            ) : (
              ""
            )} */}
          </Grid>
          <Grid xs={12} sm={4} item>
            <Typography>Date</Typography>
            <CustomTextFeildForHallSchedule
              fullWidth
              required
              value={managerFormData.date}
              onChange={(e) => {
                handleManagerFieldChange("date", e.target.value);
                setErrorMessageManagerForm({
                  ...errorMessageManagerForm,
                  date: "",
                });
              }}
              className={
                errorMessageManagerForm.date
                  ? styles.errorTextField
                  : styles.textField
              }
              inputProps={{
                readOnly: !hasManagerLevelRole,
              }}
            />
            {errorMessageManagerForm.date ? (
              <Typography sx={{ color: "red", fontSize: "12px" }}>
                {errorMessageManagerForm.date}
              </Typography>
            ) : (
              ""
            )}
            {isEmpty && hasManagerLevelRole && managerFormData.date == "" && <span style={{color:"red"}}>please enter</span>}
          </Grid>
          <Grid xs={12} sm={4} item>
            <Typography>Phone</Typography>
            <CustomTextFeildForHallSchedule
              fullWidth
              required
              disabled={!hasManagerLevelRole}
              value={managerFormData.phone}
              onChange={(e) => {
                handleManagerFieldChange("phone", e.target.value);
                setErrorMessageManagerForm({
                  ...errorMessageManagerForm,
                  phone: "",
                });
              }}
              className={
                errorMessageManagerForm.phone
                  ? styles.errorTextField
                  : styles.textField
              }
              inputProps={{
                readOnly: !hasManagerLevelRole,
              }}
            />
            {errorMessageManagerForm.phone ? (
              <Typography sx={{ color: "red", fontSize: "12px" }}>
                {errorMessageManagerForm.phone}
              </Typography>
            ) : (
              ""
            )}
            {isEmpty && hasManagerLevelRole && managerFormData.phone == "" && <span style={{color:"red"}}>please enter</span>}
          </Grid>
        </Grid>
      </Grid>
    );
  };

  const amountFieldsComponent = () => {
    return (
      <Grid>
        <Grid container spacing={2} item className={styles.gridContainer}>
        <Grid xs={12} sm={3} item>
        {CustomRequiredInputLabel(
          "Total Facility Usage ReservatIon Fees:",
          true
        )}
        <CustomTextFeildForHallSchedule
          fullWidth
          required
          value={amountData.reservationFee}
          onChange={(e) => {
            let inputValue = e.target.value;
            if (inputValue === "0") {
              inputValue = "";
            }
            const numericValue = inputValue.replace(/[^0-9.]/g, ""); // Remove non-numeric characters
            const truncatedValue = numericValue.slice(0, 10); // Allow only the first 10 numbers

            handleFieldAmountChange("reservationFee", truncatedValue);
                // setErrorMessage({
                //   ...errorMessage,
                //   ammountinDollars: "",
                // });
          }}
          className={styles.textField}
              // className={
              //   errorMessage.ammountinDollars
              //     ? styles.errorTextField
              //     : styles.textField
              // }
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <AttachMoneyIcon fontSize="small" sx={{zIndex:"1", position:"absolute"}}/>
              </InputAdornment>
            ),
            readOnly: !hasManagerLevelRole,
          }}
        />
        {isEmpty && hasManagerLevelRole && amountData.reservationFee == "" && <span style={{ color: "red" }}>please enter this field</span>}
      </Grid>
          <Grid xs={12} sm={3} item>
            {CustomRequiredInputLabel(
              "Furniture Setup, Break Down & Clng:",
              true
            )}
            <CustomTextFeildForHallSchedule
              fullWidth
              required
              value={amountData.furnitureCharges}
              onChange={(e) => {
                let inputValue = e.target.value;
                if (inputValue === "0") {
                  inputValue = "";
                }
                const numericValue = inputValue.replace(/[^0-9.]/g, ""); // Remove non-numeric characters
                const truncatedValue = numericValue.slice(0, 10); // Allow only the first 10 numbers

                handleFieldAmountChange("furnitureCharges", truncatedValue);
                // setErrorMessage({
                //   ...errorMessage,
                //   ammountinDollars: "",
                // });
              }}
              className={styles.textField}
              // className={
              //   errorMessage.ammountinDollars
              //     ? styles.errorTextField
              //     : styles.textField
              // }
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <AttachMoneyIcon fontSize="small" sx={{zIndex:"1", position:"absolute"}}/>
                  </InputAdornment>
                ),
                readOnly: !hasManagerLevelRole,
              }}
            />
            {isEmpty && hasManagerLevelRole && amountData.furnitureCharges == "" && <span style={{ color: "red" }}>please enter this field</span>}
          </Grid>
          <Grid xs={12} sm={3} item>
            {CustomRequiredInputLabel("Security Deposit", true)}
            <CustomTextFeildForHallSchedule
              fullWidth
              required
              value={amountData.securityDeposit}
              onChange={(e) => {
                let inputValue = e.target.value;
                if (inputValue === "0") {
                  inputValue = "";
                }
                const numericValue = inputValue.replace(/[^0-9.]/g, ""); // Remove non-numeric characters
                const truncatedValue = numericValue.slice(0, 10); // Allow only the first 10 numbers

                handleFieldAmountChange("securityDeposit", truncatedValue);
                // setErrorMessage({
                //   ...errorMessage,
                //   ammountinDollars: "",
                // });
              }}
              className={styles.textField}
              // className={
              //   errorMessage.ammountinDollars
              //     ? styles.errorTextField
              //     : styles.textField
              // }
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <AttachMoneyIcon fontSize="small" sx={{zIndex:"1", position:"absolute"}}/>
                  </InputAdornment>
                ),
                readOnly: !hasManagerLevelRole,
              }}
            />
          {isEmpty && hasManagerLevelRole && amountData.securityDeposit == "" && <span style={{ color: "red" }}>please enter this field</span>}
          </Grid>
          <Grid xs={12} sm={3} item>
        {CustomRequiredInputLabel(
          "Suggested Total Amount",
          true
        )}
        <CustomTextFeildForHallSchedule
          fullWidth
          required
          value={parseFloat(amountData.reservationFee) + parseFloat(amountData.furnitureCharges) + parseFloat(amountData.securityDeposit)}
          onChange={(e) => {
            let inputValue = e.target.value;
            if (inputValue === "0") {
              inputValue = "";
            }
            const numericValue = inputValue.replace(/[^0-9.]/g, ""); // Remove non-numeric characters
            const truncatedValue = numericValue.slice(0, 10); // Allow only the first 10 numbers

            // handleFieldAmountChange("reservationFee", truncatedValue);
                // setErrorMessage({
                //   ...errorMessage,
                //   ammountinDollars: "",
                // });
          }}
          className={styles.textField}
              // className={
              //   errorMessage.ammountinDollars
              //     ? styles.errorTextField
              //     : styles.textField
              // }
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <AttachMoneyIcon fontSize="small" />
              </InputAdornment>
            ),
          }}
        />
        {isEmpty && hasManagerLevelRole && amountData.reservationFee == "" && <span style={{ color: "red" }}>please enter this field</span>}
      </Grid>
          
        </Grid>
        <Grid container spacing={2} item className={styles.gridContainer}>
          <Grid xs={12} sm={3} item>
            {CustomRequiredInputLabel("Initial Amount To Be Paid", true)}
            <CustomTextFeildForHallSchedule
              fullWidth
              required
              value={status == "FORM_TO_BE_SIGNED" ? initialAmount : status == "viewcontractform" ? viewContractFormResponse.initialAmountToPay : amountData.initialAmount}
              onChange={(e) => {
                let inputValue = e.target.value;
                if (inputValue === "0") {
                  inputValue = "";
                }
                const numericValue = inputValue.replace(/[^0-9.]/g, ""); // Remove non-numeric characters
                const truncatedValue = numericValue.slice(0, 10); // Allow only the first 10 numbers

                handleFieldAmountChange("initialAmount", truncatedValue);
                // setErrorMessage({
                //   ...errorMessage,
                //   ammountinDollars: "",
                // });
              }}
              className={styles.textField}
              // className={
              //   errorMessage.ammountinDollars
              //     ? styles.errorTextField
              //     : styles.textField
              // }
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <AttachMoneyIcon fontSize="small" sx={{zIndex:"1", position:"absolute"}}/>
                  </InputAdornment>
                ),
                readOnly: !hasManagerLevelRole,
              }}
            />
            {isEmpty && hasManagerLevelRole && amountData.initialAmount == "" && <span style={{ color: "red" }}>please enter this field</span>}
          </Grid>
          <Grid xs={12} sm={3} item>
            {CustomRequiredInputLabel("Final Amount To Be Paid", true)}
            <CustomTextFeildForHallSchedule
              fullWidth
              required
              value={status == "FORM_TO_BE_SIGNED" ? finalAmount : status == "viewcontractform" ? viewContractFormResponse.finalAmountToPay :amountData.finalAmount}
              onChange={(e) => {
                let inputValue = e.target.value;
                if (inputValue === "0") {
                  inputValue = "";
                }
                const numericValue = inputValue.replace(/[^0-9.]/g, ""); // Remove non-numeric characters
                const truncatedValue = numericValue.slice(0, 10); // Allow only the first 10 numbers

                handleFieldAmountChange("finalAmount", truncatedValue);
                // setErrorMessage({
                //   ...errorMessage,
                //   ammountinDollars: "",
                // });
              }}
              className={styles.textField}
              // className={
              //   errorMessage.ammountinDollars
              //     ? styles.errorTextField
              //     : styles.textField
              // }
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <AttachMoneyIcon fontSize="small" sx={{zIndex:"1", position:"absolute"}} />
                  </InputAdornment>
                ),
                readOnly: !hasManagerLevelRole,
              }}
            />
             {isEmpty && hasManagerLevelRole && amountData.finalAmount == "" && <span style={{ color: "red" }}>please enter this field</span>}
          </Grid>
        </Grid>
      </Grid>
    );
  };

  const updatedState = (newState: boolean) => {
    setNextStep(newState);
  }

  const handleClick = () => {
    props.updateParentState(false);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  

  const FormStepContent = () => (
    <div style={{ display: "flex", justifyContent: "center" }}>
      <span className={styles.currentNumberStyle}>4</span>{" "}
      <span className={styles.totalPagesNumberStyle}>/ 9</span>
    </div>
  );

  const navigationButtons = () => {
    return (
      <div style={{ display: "flex", gap: "10px" }}>
        <CommonOutlinedButton
          startIcon={<ChevronLeftIcon />}
          onClick={handleClick}
        >
          Previous
        </CommonOutlinedButton>
        {FormStepContent()}
        <CommonButton
          endIcon={<KeyboardArrowRightIcon />}
          onClick={handleNext}
        >
          Next
        </CommonButton>
      </div>
    );
  };

const contextValue: contextTypes = { object1: {...amountData, ...managerFormData }, object2 : contextHallObject};


  return (
    <>
      {!nextStep && <div style={{ display: "flex", flexDirection: "column" }}>
        {/* <div style={{ display: "flex", gap: "1rem", float: "right", marginBottom: "40px", marginLeft: "auto" }}>
          {navigationButtons()}
        </div> */}
        <div className={styles.mainContainer}>
          <h2 style={{textAlign:"center", color:"#882E14"}}>FACILITY USAGE AGREEMENT</h2>
          <Grid>
            <Typography className={styles.typoGraphyText}>
              The facilities are provided solely for the purpose of the
              aforementioned event and shall not be used for any other purpose. Any
              violation of this allows HCCC to terminate this Agreement and retain
              all funds. Priest services “if any” will be as specified in Event Hall
              & Rooms Usage Schedule. Please note that no political functions are
              allowed in the facilities.
            </Typography>
            <Typography className={styles.typoGraphyHeading}>
              HOLD HARMLESS
            </Typography>
            <Typography className={styles.typoGraphyText}>
              I (User) certify that the above information is accurate. I certify
              that I have read the Terms and Conditions pertaining to facility use
              and agree to comply with the rules and regulations. I further agree to
              be personally responsible for informing those using the facility as
              scheduled in the application, of the rules and regulations of HCCC,
              Livermore. I, or the organization I represent agree(s) to be
              responsible for any damage sustained in the facility, equipment or
              furniture, use of facility and further agree to release and hold
              harmless the HCCC, Livermore from any and all liability for damage or
              injury to person or property of the undersigned due to the use of said
              facility
            </Typography>
          </Grid>
          {amountFieldsComponent()}
          <Typography className={styles.typoGraphyText} sx={{ margin: "16px 0" }}>
            I acknowledge that, prior to signing this agreement, I have read and
            understood the Terms and Conditions of this Agreement.
          </Typography>
          {formComponent()}
          <Divider sx={{ marginTop: "30px", color: "#000", height: "2px" }} />
          {hcccFieldsComponent()}
          <Typography className={styles.typoGraphyText}>
            1232 Arrowhead Avenue Livermore, CA 94551-6963
          </Typography>
          <Typography className={styles.typoGraphyText}>
            The signatories to this agreement acknowledge that they have the
            authority to sign this agreement.
          </Typography>

        </div>
        <FormFooter
          sign={props.sign}
          handleInputChange={props.handleInputChange}
          navigationButtons={navigationButtons()}
        />
      </div>}
      {nextStep && 
      <ContextFour.Provider value={contextValue}>
       <FormFive sign={props.sign} handleInputChange={props.handleInputChange} updateParentState={updatedState} formData={formData} />
      </ContextFour.Provider>}
    </>
  );
};

export default FacilityUsageAgreementAcknowledgement;
